module.exports = __webpack_public_path__ + "static/media/shadow-ok-36.d497b98e.png";